import React from 'react';
import { canonicalCameraAudiences } from '../../services/selfHostedCameraApi';

export const CAMERA_AUDIENCE_OPTIONS = [
  { value: 'private', label: 'Private', hint: 'Only you' },
  { value: 'public', label: 'Public', hint: 'Any signed-in Kata.fit members, never anonymous visitors' },
  { value: 'friends', label: 'Friends', hint: 'Your friends' },
  { value: 'dojo', label: 'Dojo', hint: 'Members of your dojo' },
  { value: 'dojo_chief', label: 'Dojo Chief', hint: 'Your dojo chief' },
];

// Private clears every audience; Public supersedes narrower audiences; any
// narrower choice replaces Public and combines with other narrower choices.
export function toggleCameraAudience(current, value) {
  if (value === 'private') return [];
  if (value === 'public') return (current || []).includes('public') ? [] : ['public'];
  const narrow = (current || []).filter(v => v !== 'public');
  return narrow.includes(value) ? narrow.filter(v => v !== value) : canonicalCameraAudiences([...narrow, value]);
}

export default function CameraAudienceChooser({ value, onChange, disabled = false, legend = 'Who can watch' }) {
  const isSelected = option => Array.isArray(value)
    && (option === 'private' ? value.length === 0 : value.includes(option));
  return (
    <fieldset className="camera-audience" disabled={disabled}>
      <legend>{legend}</legend>
      <div className="camera-audience-chips">
        {CAMERA_AUDIENCE_OPTIONS.map(option => (
          <label key={option.value} className={`camera-audience-chip${isSelected(option.value) ? ' selected' : ''}`} title={option.hint}>
            <input type="checkbox" disabled={disabled} checked={isSelected(option.value)}
              onChange={() => onChange(toggleCameraAudience(value, option.value))} />
            <span>{option.label}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
